import { RouteRecordRaw } from "vue-router";

import AdminHome from "@/views/admin/AdminHome.vue";
import AdminProjects from "@/views/admin/AdminProjects.vue";
import AdminEmployees from "@/views/admin/AdminEmployees.vue";
import AdminRoles from "@/views/admin/AdminRoles.vue";
import AdminGeneralManager from "@/views/admin/AdminGeneralManager.vue";
import TimesheetExplorer from "@/views/admin/TimesheetExplorer.vue";

export const AdminRoutes = {
  ADMIN: "AdminHome",
  ADMIN_PROJECTS: "AdminProjects",
  ADMIN_EMPLOYEES: "AdminEmployees",
  ADMIN_ROLES: "AdminRoles",
  ADMIN_GENERAL_MANAGER: "AdminGeneralManager",
  ADMIN_TIMESHEETS: "AdminTimesheets",
  ADMIN_AUDIT: "AdminAudit",
};

export const adminRoutes: Array<RouteRecordRaw> = [
  {
    path: "/admin",
    name: AdminRoutes.ADMIN,
    component: AdminHome,
    meta: { requiresAuth: true, requiresAdmin: true },
    redirect: { name: AdminRoutes.ADMIN_GENERAL_MANAGER },
    children: [
      {
        path: "projects",
        name: AdminRoutes.ADMIN_PROJECTS,
        component: AdminProjects,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "employees",
        name: AdminRoutes.ADMIN_EMPLOYEES,
        component: AdminEmployees,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "roles",
        name: AdminRoutes.ADMIN_ROLES,
        component: AdminRoles,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "general-manager",
        name: AdminRoutes.ADMIN_GENERAL_MANAGER,
        component: AdminGeneralManager,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "timesheets",
        name: AdminRoutes.ADMIN_TIMESHEETS,
        component: TimesheetExplorer,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
    ],
  },
];
